export enum PageType {
  HomePage = 'homepage',
  SkinnyBannerPage = 'skinnybanner',
  Plp = 'plp',
}
